import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
// import './mock' // mock 数据模拟, 不使用时直接注释即可
import vuescroll from 'vuescroll'
// import infiniteScroll from 'vue-infinite-scroll'
import Icon from 'vue-awesome/components/Icon' // 全局引入 vue-awesome 组件 icons icons/brands icons/regular
import YioksLoading from './components/YioksLoading' // 引入自定义组件，全局注册
import YioksEmpty from './components/YioksEmpty'
import YioksTip from './components/YioksTip'
import YioksDialog from './components/tips/DialogWrap'
import YioksPagination from "./components/Pagination"
import YioksContent from "./components/layout/list"
import yioksConfig from './mixin/yioksConfig'
import {Base64} from 'js-base64'
Vue.prototype.$Base64 = Base64;

import rules from './utils/formRules/rules'
import { time,timeMonth,timeYear,timeYearAndMonth } from '@/utils/yioks_filter'
import {
  Autocomplete,
  Tooltip,
  Pagination,
  Dialog,
  Button,
  Form,
  FormItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Input,
  Select,
  Option,
  Row,
  Col,
  Upload,
  Message,
  Tag,
  DatePicker,
  Switch,
  Slider,
  Radio,
  RadioGroup,
  Checkbox,
  infiniteScroll,
  TimePicker,
  CheckboxGroup,
  Steps,
  Step,
  Rate,
  Popconfirm,
  Popover,
  InputNumber,
  Divider,
  Table,
  TableColumn,
  Progress,
  TimeSelect,
} from 'element-ui'
import storage from '@/utils/storage'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { enMessage } from '@/assets/message/en'
import { zhMessage } from '@/assets/message/zh'
Vue.use(VueI18n)
const messages = {
  zh: {
    ...zhMessage,
    ...zhLocale
  },
  en: {
    ...enMessage,
    ...enLocale
  }
}
const i18n = new VueI18n({
  locale: storage.get('languageType') || 'zh', // 语言标识
  messages
})
Vue.use(vuescroll, { ops: { // 全局引入注入 vuescroll ，并设置其公共配置
  rail: {
    size: '10px',
    background: '#FFF',
    opacity: 0.2,
    gutterOfSide: '5px' // 距离容器的距离
  },
  bar: {
    onlyShowBarOnScroll: false, // 只有在滚动的时候显示bar
    background: '#FFF',
    opacity: 0.3,
    size: '10px',
    keepShow: true // 保持显示滚动条
  },
  vuescroll: {
    wheelScrollDuration: 300
  }
}
})

Vue.component('v-icon', Icon) // 全局注册组件 v-icon, 图标在使用页面单独引入
Vue.use(Tooltip) // 提示
Vue.use(Pagination) // 分页
Vue.use(Autocomplete)
Vue.use(Dialog) // 对话框
Vue.use(Button) // 按钮
Vue.use(Form) // 表单
Vue.use(FormItem) // 表单中的一项
Vue.use(Input) // input
Vue.use(Select) // select
Vue.use(Option) // option
Vue.use(Row) // 栅格化行
Vue.use(Col) // 栅格化单元格
Vue.use(Upload) // 上传
Vue.use(Tag) // 标签
Vue.use(DatePicker) // 日期组件
Vue.use(TimeSelect) // 时间组件
Vue.use(Switch) // 开关组件
Vue.use(Slider) // 滑块
Vue.use(Radio) // 单选
Vue.use(RadioGroup) // 单选组
Vue.use(Dropdown) // 下拉框
Vue.use(DropdownItem) // 下拉框
Vue.use(DropdownMenu) // 下拉框
Vue.use(Checkbox) // 下拉框
Vue.use(TimePicker)
Vue.use(CheckboxGroup)
Vue.use(infiniteScroll) // 下拉框
Vue.use(Steps) // 步骤组件
Vue.use(Step) // 步骤组件
Vue.use(Rate); //评分
Vue.use(Popconfirm); //确认
Vue.use(Popover); //气泡弹出窗
Vue.use(InputNumber); //数字输入框
Vue.use(Divider); //数字输入框
Vue.use(Table); //表格
Vue.use(TableColumn); //表格
Vue.use(Progress); //气泡弹出窗
Vue.prototype.$message = Message // 消息提示
Vue.component('yioks-loading', YioksLoading)
Vue.component('yioks-empty', YioksEmpty)
Vue.component('yioks-tip', YioksTip)
Vue.component('yioks-dialog', YioksDialog)
Vue.component('yioks-pagination', YioksPagination)
Vue.component('yioks-content', YioksContent)

// 全局时间过滤器
Vue.filter('time', time)
Vue.filter('timeMonth', timeMonth)
Vue.filter('timeYear', timeYear)
Vue.filter('timeYearAndMonth', timeYearAndMonth)

Vue.prototype.$rule = rules // 将验证规则绑定到 vue 原型上，通过 this.$rule 调用
Vue.prototype.$yioksConfig = yioksConfig // 挂在平台配置信息
Vue.config.productionTip = false // 阻止启动生产消息

import ok from './ok-utils/ok.js';
Vue.prototype.$ok = ok;

// 刷新页面给 state 中的 userInfo 重新赋值（因为会置空）
store.commit('setUserInfo');
store.commit('setRenewYouthNum');

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     if (storage.get('token')) {
//       next()
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

import okFile from './utils/ok.js';
Vue.prototype.$okFile = okFile;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
